export default {
    data: function () {
        return {
            service: '',
            reloadBus: null,
            defaultFormModel: {},
            showForm: false,
            formModel: {},
            formTitle: '',
            formErrors: [],
            updateLoading: false,
            saveLoading: false,
            delLoading: false,
        }
    },
    methods: {
        create: function () {
            this.formModel = {};
            this.formModel = Object.assign({}, this.defaultFormModel);
            this.formTitle = this.$t('create');
            this.formErrors = [];
            this.showForm = true;
        },
        update: function (id) {
            let uri = this.service;
            if (id) {
                uri += '/' + id;
            }
            this.updateLoading = true;
            this.$service.get(uri).then(response => {
                this.formModel = {};
                this.formTitle = this.$t('update');
                this.formErrors = [];
                this.showForm = true;
                this.formModel = response.data;
                this.formModel.id = id;
            }).finally(() => {
                this.updateLoading = false;
            });
        },
        save: function (evt) {
            if(evt) {
                evt.preventDefault();
            }
            this.saveLoading = true;
            let method = 'post';
            let url = this.service;
            if (this.formModel.id) {
                method = 'put';
                url += '/' + this.formModel.id;
            }
            return this.$service({url: url, method: method, data: this.formModel}).then(response => {
                this.showForm = false;
                if (this.load) {
                    this.load();
                }
                if (this.reloadBus) {
                    this.$bus.$emit(this.reloadBus);
                }
                if (response.data) {
                    this.$swal({
                        title: this.$t('success'),
                        text: this.$t(this.formModel.id ? 'updated' : 'created'),
                        icon: 'success',
                        toast: true,
                        position: 'top-end',
                        timer: 5000,
                    });
                } else {
                    this.$swal({
                        title: this.$t('error'),
                        text: this.$t(this.formModel.id ? 'updateFailed' : 'createFailed'),
                        icon: 'error',
                        toast: true,
                        position: 'top-end',
                        timer: 5000,
                    });
                }
                return response.data;
            }).catch(error => {
                if (error.response.data.message) {
                    this.$swal({
                        text: error.response.data.message,
                        icon: 'error'
                    });
                    this.showForm = false;
                } else {
                    this.formErrors = error.response.data;
                }
            }).finally(() => {
                this.saveLoading = false;
            });
        },
        del: function (id) {
            this.$swal({
                title: this.$t('deleteConfirm'),
                text: this.$t('deleteAlert'),
                icon: "warning",
                showCancelButton: true
            }).then((result) => {
                if (result.value) {
                    this.delLoading = true;
                    this.$service.delete(this.service + '/' + id).then(response => {
                        if (response.data) {
                            if (this.load) {
                                this.load();
                            }
                            if (this.reloadBus) {
                                this.$bus.$emit(this.reloadBus);
                            }
                            this.$swal({
                                title: this.$t('success'),
                                text: this.$t('deleted'),
                                icon: 'success',
                                toast: true,
                                position: 'top-end',
                                timer: 5000,
                            });
                        } else {
                            this.$swal({
                                title: this.$t('error'),
                                text: this.$t('deleteFailed'),
                                icon: 'error',
                                toast: true,
                                position: 'top-end',
                                timer: 5000,
                            });
                        }
                    }).catch(error => {
                        if (error.response.data.message) {
                            this.$swal({
                                text: error.response.data.message,
                                icon: 'error'
                            });
                        }
                    }).finally(() => {
                        this.delLoading = false;
                    });
                }
            });
        },
    },
    mounted: function () {
        this.formModel = {};
        this.formModel = Object.assign({}, this.defaultFormModel);
    }
};